module.exports = __webpack_public_path__ + "static/wordpress-49163b77e3236662ad652b078e310670.png";